import LinkConstants from 'constants/LinkConstants';
import { SyncType } from 'globalTypes';

export type SyncTypeTextProperties = {
  image: string;
  continueWith: string;
  switchTo: string;
  footerText: string;
  footerNextSyncType: SyncType;
  text: string;
  textLink: string;
  subtext: string;
  nextSyncType: SyncType;
  subtextv2: string;
  titlev2: string;
  imagev2: string;
};

const syncTypeConstants = {
  ONEROSTER: {
    image: require('assets/images/rostering/csv-oneroster.png'),
    continueWith: 'OneRoster',
    switchTo: 'Remind CSV 2.0',
    footerText: 'Remind CSV 2.0 format',
    footerNextSyncType: SyncType.remindSpreadsheetV2,
    text: 'Remind OneRoster CSV format',
    textLink: LinkConstants.FORMAT_ONEROSTER,
    subtext: 'Remind',
    nextSyncType: SyncType.remindSpreadsheetV2,
    titlev2: 'OneRoster',
    subtextv2: 'Export CSV files in the OneRoster format and transfer them to Remind through SFTP.',
    imagev2: require('assets/images/rostering/csv-oneroster_2.png'),
  },
  REMIND: {
    image: require('assets/images/rostering/csv-remindv1.png'),
    continueWith: 'Remind CSV 1.0',
    switchTo: 'Remind CSV 2.0',
    footerText: 'Remind CSV 2.0 format',
    footerNextSyncType: SyncType.remindSpreadsheetV2,
    text: 'old Remind CSV format 1.0',
    textLink: LinkConstants.FORMAT_REMIND,
    subtext: 'Remind OneRoster',
    nextSyncType: SyncType.oneRosterSpreadsheet,
    titlev2: '',
    subtextv2: '',
    imagev2: require('assets/images/rostering/csv-remindv1.png'),
  },
  REMIND2: {
    image: require('assets/images/rostering/csv-remindv2.png'),
    continueWith: 'Remind CSV 2.0',
    switchTo: 'OneRoster',
    footerText: 'Remind CSV format 1.0',
    footerNextSyncType: SyncType.remindSpreadsheet,
    text: 'Remind CSV 2.0 format',
    textLink: LinkConstants.FORMAT_REMINDV2,
    subtext: 'Remind OneRoster',
    nextSyncType: SyncType.oneRosterSpreadsheet,
    titlev2: 'Remind CSV 2.0',
    subtextv2: 'Export CSV files from any SIS and transfer them to Remind through SFTP.',
    imagev2: require('assets/images/rostering/csv-remindv2_2.png'),
  },
  CLASSLINK: {
    image: require('assets/images/rostering/classlink.png'),
    continueWith: '',
    switchTo: '',
    footerText: '',
    footerNextSyncType: SyncType.classlink,
    text: '',
    textLink: LinkConstants.FORMAT_CLASSLINK,
    subtext: '',
    nextSyncType: SyncType.classlink,
    titlev2: 'ClassLink',
    subtextv2: 'Directly sync your SIS and Remind through ClassLink.',
    imagev2: require('assets/images/rostering/classlink.png'),
  },
};

export const textFromSyncType: { [id: string]: SyncTypeTextProperties } = {
  classlink: syncTypeConstants.CLASSLINK,
  remindSpreadsheet: syncTypeConstants.REMIND,
  remindSpreadsheetV2: syncTypeConstants.REMIND2,
  oneRosterSpreadsheet: syncTypeConstants.ONEROSTER,
};

export default syncTypeConstants;
